import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randFloat, randNumber } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import { roundEven, toNumber } from '@/utils/number.js'

type AlternativePriceModel = SchemaAttributes<'AlternativePrice'>

export const model = Model.extend({
  invoiceRow: belongsTo('invoiceRow'),
}) as ModelDefinition<AlternativePriceModel>

export const factory = Factory.extend<AlternativePriceModel>({
  quantity() {
    return randNumber({ min: 1, max: 10 })
  },
  usage_size() {
    return 'USAGE_SIZE_PACKAGE'
  },
  alternative_quantity() {
    return randNumber({ min: 1, max: 20 })
  },
  alternative_price() {
    return roundEven(
      toNumber(randFloat({ min: 10, max: 100, precision: 4 })),
      4,
    )
  },
  alternative_price_with_vat() {
    return roundEven(toNumber(this.alternative_price) * 1.23, 4)
  },
})
